module.exports = __webpack_public_path__ + "static/img/pic-qrcode-default.309d8b6.png";